'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export function NavLinkClient({
	href,
	icon,
	label
}: {
	href: string;
	icon: React.ReactNode;
	label: string;
}) {
	const pathname = usePathname();
	const isActive = pathname === href || (href === '/' && pathname === '/dashboard');

	return (
		<Link
			href={href}
			className={`flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors relative ${
				isActive
					? 'text-emerald-600 bg-emerald-50'
					: 'text-gray-700 hover:text-emerald-600 hover:bg-emerald-50'
			} rounded-md`}
		>
			{icon}
			{label}
			{isActive && (
				<div className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-600 rounded-full"></div>
			)}
		</Link>
	);
}
